<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
        <v-col class="pa-0">
            <show
                :id="id"
                :model-def="modelDef"
                :model-class="modelClass"
                :activities="true"
                :fileuploader="true">
                <template slot="relations">
                    <belongstomany-show
                        class="pb-4"
                        :headers="headers"
                        title="Destinatari WhatsApp"
                        paginate
                        :url="'whatsappcampaignrecipients-filters/' + id">
                    </belongstomany-show>
                </template>
            </show>
        </v-col>
    </v-row>
</template>

<script>
import BelongstomanyShow from '@/components/common/BelongstomanyShow'

export default {
    name: 'WhatsAppCampaign',

    components: {
        BelongstomanyShow,
    },

    props: {
        id: Number,
    },

    data() {
        return {
            modelDef: 'whatsappcampaigns',
            modelClass: 'whatsappcampaign',
            headers: [
                {
                    'text': '#',
                    'sortable': false,
                    'value': 'number',
                    'width': '40'
                },
                {
                    'text': 'Azienda',
                    'sortable': false,
                    'value': 'company',
                },
                {
                    'text': 'Numero Telefono',
                    'sortable': false,
                    'value': 'telephone_number',
                },
                {
                    'text': 'Stato',
                    'sortable': false,
                    'value': 'whatsapp_status',
                },
                {
                    'text': 'Consegnato',
                    'sortable': false,
                    'value': 'whatsapp_delivered_at',
                    'type': 'date',
                },
                {
                    'text': 'Letto',
                    'sortable': false,
                    'value': 'whatsapp_read_at',
                    'type': 'date',
                },
                {
                    'text': 'Errore',
                    'sortable': false,
                    'value': 'whatsapp_error',
                }
            ]
        }
    },

    created() {
        this.$store.commit('endProgress')
    }
}
</script>
